import { render, staticRenderFns } from "./DuvidasFrequentes.vue?vue&type=template&id=65151afd&scoped=true"
import script from "./DuvidasFrequentes.vue?vue&type=script&lang=js"
export * from "./DuvidasFrequentes.vue?vue&type=script&lang=js"
import style0 from "./DuvidasFrequentes.vue?vue&type=style&index=0&id=65151afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65151afd",
  null
  
)

export default component.exports